import { Box } from '@chakra-ui/react';
import { useEffect } from 'react';
import NavigationScroll from '../../../../components/Navigation/NavigationScroll';
import { formattedDate3 } from '../../../../helper/utils/formattedDate';
import { isEmptyObject } from '../../../../helper/utils/isEmptyObject';
import { urlNavigate } from '../../../../helper/utils/navigation';
import FloatingCheckoutButton from '../../components/FloatingCheckoutButton';
import ProductList from '../../components/ProductList';
import ProductsOverview from '../../components/ProductsOverview';
import useOnlineSales from '../../hooks/useOnlineSales';
import usePages from '../../hooks/usePages';

export default function AddOnPage() {
    const { groupedData, loading, loadingOrder, selectedDate, handleGetProductAvailability } = useOnlineSales();
    const { page } = usePages();

    useEffect(() => {
        handleGetProductAvailability('addon', formattedDate3(selectedDate));
    }, []);

    return (
        <NavigationScroll>
            <Box w='full'>
                <ProductsOverview
                    products={groupedData}
                    overview={{ title: 'Add on', desc: '*Optional. You can add items to complete your order.', ctaTitle: 'Explore Product' }}
                    type='addon'
                    isLoading={loadingOrder || loading}
                    onGetProducts={() => {
                        if (selectedDate) {
                            handleGetProductAvailability('addon', formattedDate3(selectedDate));
                        }
                    }}
                />
                <FloatingCheckoutButton to={`${urlNavigate('online-sales', 'checkout')}`} />
                {!isEmptyObject(page) && <ProductList product={page['products'] || {}} />}
            </Box>
        </NavigationScroll>
    );
}
